"use strict"

import React from "react"
import ReactNative from "react-native"
import { connect } from "react-redux"
import { colors } from "app/lib/styles"
import { truncate } from "app/lib/utils/text"
import Device from "app/lib/Device"
import dataStore from "app/data/dataStore"

import Loading from "app/components/Loading"
import ProfileHeader from "./components/ProfileHeader"
import ChallengeHistory from "./ChallengeHistory"
import ChallengeProgressBar from "./components/ChallengeProgressBar"
import ChallengeProgressBarLegend from "./components/ChallengeProgressBarLegend"
import ChallengeStats from "app/components/ChallengeStats"
import FS from "app/components/FS"

import { switchTab, navigateTo } from "app/actions/app"

import { updateChallengeStats } from "app/actions/challenges"

const { View, InteractionManager, StyleSheet } = ReactNative

class Progress extends FS.View {
  constructor(props) {
    super(props)
  }

  getMyUrl() {
    return "profile/progress"
  }

  getTraits() {
    return {
      id: this.props.user.id,
    }
  }

  componentDidMount() {
    this.props.dispatch(updateChallengeStats(this.props.challenges.stats === null))
  }

  handleJoinChallengePress = () => {
    this.props.dispatch(switchTab("mychallenge"))
  }

  handleStatPress = challenge => {
    this.props.dispatch(
      navigateTo("challenge_history", {
        title: truncate(challenge.name, 22),
        challengeId: challenge.id,
      })
    )
  }

  renderChallenge(stats) {
    var challenge = dataStore.get("challenge", stats.challenge_id)
    var currSubId = this.props.challenges.latestChallengeSubscriptionId
    var inProgress = false
    if (
      currSubId &&
      dataStore.get("challenge_subscription", currSubId).challenge_id === challenge.id
    ) {
      inProgress = true
    }
    return (
      <FS.Touchable
        style={[styles.challengeWrap, inProgress ? styles.challengeWrapInProgress : null]}
        key={stats.challenge_id}
        onPress={() => this.handleStatPress(challenge)}
      >
        {inProgress ? (
          <View style={styles.challengeInProgressHeader}>
            <FS.Text style={styles.challengeInProgressHeaderText}>In Progress</FS.Text>
          </View>
        ) : null}
        <FS.Text style={styles.challengeName} numberOfLines={1}>
          {challenge.name}
        </FS.Text>
        <ChallengeStats stats={stats} />
        <ChallengeProgressBar stats={stats} style={styles.progressBar} />
        {inProgress ? <ChallengeProgressBarLegend stats={stats} /> : null}
      </FS.Touchable>
    )
  }

  renderChallengeStats() {
    var stats = this.props.challenges.stats
    if (stats && stats.length > 0) {
      return (
        <View style={styles.challengeStatsOuterWrap}>
          {stats.map(challengeStats => this.renderChallenge(challengeStats))}
        </View>
      )
    } else {
      return (
        <View style={styles.noChallengeWrap}>
          <FS.Text style={styles.noChallengeText}>
            Your challenge summary stats will be here.
          </FS.Text>
          <FS.Touchable
            onPress={this.handleJoinChallengePress}
            style={styles.noChallengeButton}
          >
            <FS.Text style={styles.noChallengeButtonText}>Join a challenge</FS.Text>
          </FS.Touchable>
        </View>
      )
    }
  }

  renderLoading() {
    return <Loading style={styles.loading} />
  }

  render() {
    return (
      <FS.ScrollView
        style={styles.container}
        contentContainerStyle={styles.contentContainer}
        ref={this.props.scrollViewRef}
      >
        <ProfileHeader {...this.props} />
        <View style={styles.content}>
          {this.props.challenges.fetchingStats
            ? this.renderLoading()
            : this.renderChallengeStats()}
        </View>
      </FS.ScrollView>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return Object.assign({}, state.profile, {
    challenges: state.challenges,
    currentUserId: state.app.currentUserId,
    selectedTab: state.app.selectedTab,
    buddies: state.buddies,
  })
}

export default connect(mapStateToProps)(Progress)

var styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: colors.challengeBlue,
  },
  contentContainer: {
    backgroundColor: colors.lightGray,
    minHeight: Device.height,
    justifyContent: "flex-start",
  },
  content: {
    padding: 7,
  },
  loading: {
    margin: 40,
  },
  challengeWrap: {
    backgroundColor: colors.white,
    padding: 18,
    borderRadius: 4,
    marginVertical: 10,
  },
  challengeName: {
    textAlign: "center",
    fontSize: 16,
    fontWeight: "600",
    color: colors.challengeBlue,
    letterSpacing: -0.3,
    marginBottom: 24,
  },
  statsWrap: {},
  statWrap: {
    justifyContent: "center",
    alignItems: "center",
    marginHorizontal: 15,
  },
  private: {
    color: colors.mediumGray,
    fontSize: 10,
    marginTop: 4,
    marginBottom: 0,
    textAlign: "center",
  },
  noChallengeWrap: {
    padding: 20,
  },
  noChallengeText: {
    color: colors.darkGray,
    textAlign: "center",
    alignItems: "center",
  },
  noChallengeButton: {
    backgroundColor: colors.darkGray,
    padding: 12,
    borderRadius: 4,
    marginTop: 12,
  },
  noChallengeButtonText: {
    textAlign: "center",
    color: colors.white,
  },
  progressBar: {
    marginHorizontal: 10,
  },
  challengeWrapInProgress: {
    borderColor: colors.challengeDarkBlue,
    borderWidth: 2,
  },
  challengeInProgressHeaderText: {
    color: colors.white,
    textAlign: "center",
    fontWeight: "500",
  },
  challengeInProgressHeader: {
    backgroundColor: colors.challengeDarkBlue,
    marginTop: -20,
    marginLeft: -20,
    marginRight: -20,
    marginBottom: 20,
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    paddingVertical: 8,
  },
})
